import { api } from './apiInstances';

// Obtener Datos para la tabla
export const getAllTemplatesRequest = async (body) => {
  const result = await api.post(`/v2/PlantillaSolicitudServicio/grid`, body);

  return result.data;
};

// Post plantilla solicitud de servicio
export const postTemplateRequest = async (body) => {
  const result = await api.post(`/v1/PlantillaSolicitudServicio`, body);

  return result.data;
};

// Put plantilla solicitud de servicio
export const updateTemplateRequest = async (body) => {
  const result = await api.put(`/v1/PlantillaSolicitudServicio`, body);

  return result.data;
};

// Delete platillas de solicitud de servicio
export const deleteTemplatesRequest = async (ids) => {
  const result = await api.delete(`/v1/PlantillaSolicitudServicio`, {
    data: ids
  });

  return result.data;
};

// Replicar plantilla solicitud de servicio
export const replicateTemplateRequest = async (id) => {
  const result = await api.get(`/v1/PlantillaSolicitudServicio/${id}/replicar`);

  return result.data;
};

// Obtener plantilla solicitud de servicio
export const getTemplateRequest = async (id) => {
  const result = await api.get(`/v1/PlantillaSolicitudServicio/${id}`);

  return result.data;
};

// Archivos adjuntos de plantilla solicitud de servicio
// Subir archivo adjunto
export const uploadFileTemplateRequest = async (id, body) => {
  const result = await api.post(`/v1/PlantillaSolicitudServicio/archivosAdjuntos/${id}`, body);

  return result.data;
};

// Obtener archivo adjunto
export const downloadTemplateRequest = async (id) => {
  const result = await api.get(`/v1/PlantillaSolicitudServicio/${id}/download`);

  return result.data;
};

// Eliminar archivo adjunto
export const deleteFileTemplateRequest = async (id, idsArchivos) => {
  const result = await api.delete(`/v1/PlantillaSolicitudServicio/${id}/archivoAdjunto`, {
    data: idsArchivos
  });

  return result.data;
};

// Get archivos de una solicitud, esto lo consultamos cuando subimos un archivo en un borrador
// enotnces necesitamos el id por si lo queremos borrar
// TODO: /v1/PlantillaSolicitudServicio/{idPlantillaSolicitudServicio}/listadoArchivosAdjuntos
export const getFilesIdsFromTemplateRequest = async (id) => {
  const result = await api.get(`/v1/PlantillaSolicitudServicio/${id}/listadoArchivosAdjuntos`);

  return result.data;
};

// Cuando realizamos una plantilla a partir de un borrador
// una plantilla a partir de una solicitud
// o una solicitud a partir de una solicitud (replicar)
// debemos indicarle al back de que a que vamos
// para que ellos puedan buscar y copiar los archivos correspondientes

export const copyFilesFromOneRequestToAnother = async (formId, toId, arrayOfFiles, typeOfCopy) => {
  const body = {
    idOrigen: formId,
    idDestino: toId,
    nombresDeArchivos: arrayOfFiles,
    tipoOrigenYDestino: typeOfCopy
  };

  const result = await api.post('/v1/PlantillaSolicitudServicio/copiarArchivosAdjuntos', body);

  return result.data;
};
